// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".import_result {\n  margin-right: 20px;\n}\n.import_failed {\n  margin-top: 10px;\n  :first-child-margin-bottom: 5px;\n  :first-child-font-weight: bold;\n}", ""]);
// Exports
module.exports = exports;
